export default "__VITE_ASSET__c97ef4fd__"